import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

import { COLOR_PALETTE } from '../constants/palette.constant';

export const MuiAlert = (baseTheme: Theme): Partial<Components> => ({
  MuiAlert: {
    styleOverrides: {
      root: {
        padding: '10px',
        display: 'flex',
        borderRadius: '8px',
        alignItems: 'center',
      },

      filledError: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: baseTheme.palette.error.main,
        '& svg': { fill: baseTheme.palette.common.white },
      },
      //TODO: Remove display: none style for icon and use overrideIcon prop in BDAlerts
      filledInfo: {
        backgroundColor: COLOR_PALETTE.common.sky80,
        '& .MuiAlert-icon': {
          display: 'none',
        },
        '& .MuiAlert-message': {
          color: baseTheme.palette.text.primary,
          '& .MuiLink-underlineHover': {
            color: 'inherit',
            textDecoration: 'underline',
          },
        },
        '& a': {
          color: 'inherit',
        },
      },

      filledWarning: {
        backgroundColor: baseTheme.palette.warning.main,
        '& .MuiAlert-message, & svg': {
          color: baseTheme.palette.common.white,
          '& .MuiLink-underlineHover': {
            color: 'inherit',
            textDecoration: 'underline',
          },
        },
        '& svg': {
          fill: baseTheme.palette.common.white,
        },
        '& a': {
          color: 'inherit',
          textDecoration: 'underline',
        },
      },

      filledSuccess: {
        backgroundColor: baseTheme.palette.success.main,
      },
      outlinedError: {
        color: baseTheme.palette.error.main,
        border: '1px solid',
        '& .MuiAlert-message': {
          color: baseTheme.palette.error.main,
        },
        '& .MuiSvgIcon-root': {
          fill: baseTheme.palette.error.main,
        },
      },
      outlinedInfo: {
        border: '1px solid',
        color: COLOR_PALETTE.common.sky80,
        '& .MuiAlert-message': {
          color: baseTheme.palette.text.primary,
        },
        '& .MuiSvgIcon-root': {
          fill: COLOR_PALETTE.common.sky80,
        },
      },
      outlinedWarning: {
        border: '1px solid',
        color: baseTheme.palette.warning.main,
        '& .MuiAlert-message': {
          color: baseTheme.palette.text.primary,
        },
        '& .MuiSvgIcon-root': {
          fill: baseTheme.palette.warning.main,
        },
      },
      outlinedSuccess: {
        border: '2px solid',
        color: baseTheme.palette.success.main,
        '& .MuiAlert-message': {
          color: baseTheme.palette.text.primary,
        },
        '& .MuiSvgIcon-root': {
          fill: baseTheme.palette.success.main,
        },
      },
      standardError: {
        backgroundColor: baseTheme.palette.common.white,
        '& .MuiAlert-message': {
          color: baseTheme.palette.text.primary,
        },
        '& .MuiSvgIcon-root': {
          color: baseTheme.palette.error.main,
        },
      },
      standardInfo: {
        backgroundColor: baseTheme.palette.common.white,
        '& .MuiAlert-message': {
          color: baseTheme.palette.text.primary,
        },
        '& .MuiSvgIcon-root': {
          fill: COLOR_PALETTE.common.sky80,
        },
      },
      standardWarning: {
        backgroundColor: baseTheme.palette.common.white,
        '& .MuiAlert-message': {
          color: baseTheme.palette.text.primary,
        },
        '& .MuiSvgIcon-root': {
          fill: baseTheme.palette.warning.main,
        },
      },
      standardSuccess: {
        backgroundColor: baseTheme.palette.common.white,
        '& .MuiAlert-message': {
          color: baseTheme.palette.text.primary,
        },
        '& .MuiSvgIcon-root': {
          fill: baseTheme.palette.success.main,
        },
      },
      icon: {
        marginRight: '10px',
        padding: '0',
      },
      message: {
        padding: '0',
        fontSize: '0.875em',
      },
    },
  },
});
